import { applyMiddleware, combineReducers, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { all } from "typed-redux-saga";
import { componentAdvosysInitStore, componentAdvosysReducer, componentAdvosysSagaInit } from "@advosys/component-advosys-react";
import { getAppServerSettings } from "@advosys/component-app-server-client-js";
import { composeWithDevTools } from "@redux-devtools/extension";
import * as application from "src/domains/application";
import * as authentication from "src/domains/authentication";
import * as dynamicInvoice from "src/domains/dynamic-invoice";
import * as settings from "src/domains/settings";
const globalReducer = combineReducers({
    componentAdvosys: componentAdvosysReducer,
    application: application.reducer,
    authentication: authentication.reducer,
    dynamicInvoices: dynamicInvoice.dynamicInvoicesReducer,
    settings: settings.reducer
});
componentAdvosysInitStore({ getState: (state) => state.componentAdvosys });
function* saga() {
    yield* all([...componentAdvosysSagaInit(), ...application.applicationDomainSagaInit(), ...authentication.authenticationDomainSaga(), ...dynamicInvoice.dynamicInvoiceSagaInit()]);
}
export const createApplicationStore = () => {
    const apiServerUrl = `https://${getAppServerSettings().baseUrl}/advosys/`;
    const initialState = {
        settings: {
            settings: { apiServerUrl }
        }
    };
    let store;
    const sagaMiddleware = createSagaMiddleware({
        onError: error => {
            store.dispatch(application.errorHandlerActions.showError(error.message));
        }
    });
    const enhancer = composeWithDevTools(applyMiddleware(sagaMiddleware));
    store = createStore(globalReducer, initialState, enhancer);
    sagaMiddleware.run(saga);
    return store;
};
